module.exports = __webpack_public_path__ + "static/img/waitting.3a177ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/waitting.png
// module id = X1F3
// module chunks = 1